// extracted by mini-css-extract-plugin
module.exports = {"clientCardWrap":"style_clientCardWrap__wagfF"};